import getCharts from '../getCharts'
import { PatientInsurance } from '../../constants/api.config'

export default async function PatientInsuranceFn(Mode, Insurance, PatientID = "-1" ) {
  try {
    const payload = {Mode, Insurance, PatientID}
    const res = await getCharts(PatientInsurance, payload)
    return res.data
  } catch (error) {
    return error
  }
}
